import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static values = {
    copyCopiedTranslation: String,
    copyUnableTranslation: String,
    silent: { type: Boolean, default: false },
    newTranslation: String,
    newIcon: { type: String, default: "circle-check" }
  }

  copy(event) {
    this.clickedElement = event.currentTarget
    this.writeToClipboard(this.textToCopy)
  }

  // Private

  writeToClipboard(text) {
    navigator.clipboard.writeText(text).then(() => {
      if (this.silentValue) {
        this.changeButtonAppearance();
      } else {
        alert(this.copyCopiedTranslationValue);
      }
    }, () => {
      alert(this.copyUnableTranslationValue)
    })
  }

  get textToCopy() {
    return this.data.get("text-to-copy")
  }

  changeButtonAppearance() {
    const originalContent = this.clickedElement.innerHTML
    const iconMargin = this.newTranslationValue ? "mr-2" : "mr-0"
    this.clickedElement.disabled = true
    this.clickedElement.innerHTML = `<span class="d-flex justify-content-center align-items-center"><i class="fa-solid ${iconMargin} fa-${this.newIconValue}"></i><span>${this.newTranslationValue}</span></span>`

    setTimeout(() => {
      this.clickedElement.innerHTML = originalContent
      this.clickedElement.disabled = false
    }, 2000);
  }
}
